import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent } from 'components/ui/card';
import { Tooltip, TooltipContent, TooltipTrigger } from 'components/ui/tooltip';
import { Info } from 'lucide-react';
import { formatNumber } from 'helpers';

const StatsGrid = ({ stats }) => {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.name} className="bg-white rounded-sm border border-gray-200 relative overflow-hidden">
          <CardContent className="p-3">
            <div className="flex items-center justify-between mb-2">
              <p className="font-normal text-gray-800 flex items-center gap-1">
                {stat.name}
                {stat.description && (
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <Info size={12} />
                    </TooltipTrigger>
                    <TooltipContent>
                      <p className="max-w-xs text-sm">{stat.description}</p>
                    </TooltipContent>
                  </Tooltip>
                )}
              </p>
            </div>

            <div className="flex justify-between items-center">
              <span className="text-2xl font-bold text-gray-900">{formatNumber(stat.value)}</span>
              {stat.percent != null && (
                <span className="text-xs text-gray-600 mt-1">{Number(stat.percent).toFixed(1)}%</span>
              )}
            </div>
          </CardContent>

          {stat.percent != null && (
            <div className="absolute top-0 right-0 bottom-0 w-1 bg-gray-100">
              <div
                className="absolute bottom-0 right-0 w-full bg-green-800 rounded-t-sm transition-all duration-300"
                style={{ height: `${Math.min(100, Math.max(0, Number(stat.percent)))}%` }}
              />
            </div>
          )}
        </Card>
      ))}
    </div>
  );
};

StatsGrid.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      percent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
};

export default StatsGrid;
